module.exports = __webpack_public_path__ + "img/health-checkup-package.2a666774.png";